export default {
  // About Admin
  "configAboutAdmin.add": "添加",
  "configAboutAdmin.details": "详情",
  "configAboutAdmin.edit": "编辑",
  "configAboutAdmin.delete": "删除",
  "configAboutAdmin.delete.confirm.title": "删除配置",
  "configAboutAdmin.delete.confirm.content": "确定要删除这个配置吗？",
  "configAboutAdmin.delete.confirm.okText": "确定",
  "configAboutAdmin.delete.confirm.cancelText": "取消",
  "configAboutAdmin.modal.title": "关于我们配置",
  "configAboutAdmin.thead.createdAt": "创建时间",
  "configAboutAdmin.thead.updatedAt": "更新时间",
  "configAboutAdmin.thead.action": "操作",

  // About fields
  "configAboutAdmin.thead.id": "ID",
  "configAboutAdmin.thead.documentId": "文档ID",
  "configAboutAdmin.thead.itemName": "名称",
  "configAboutAdmin.thead.content": "内容",
  "configAboutAdmin.thead.itemId": "标识",
  "configAboutAdmin.thead.seo": "SEO",
  "configAboutAdmin.thead.groupId": "分组ID",
  "configAboutAdmin.thead.bindSite": "绑定站点",
  "configAboutAdmin.thead.createdBy": "创建者",
  "configAboutAdmin.thead.updatedBy": "更新者",
  "configAboutAdmin.thead.publishedAt": "发布时间",
  "configAboutAdmin.thead.locale": "语言环境",
  "configAboutAdmin.thead.localizations": "本地化",
  "configAboutAdmin.thead.status": "状态",
};
